export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  buttons: {
    min: 0,
    max: 2
  }
}
